//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "columnWidth-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  inject: ['isSubFormChildWidget']
};